module.exports = __webpack_public_path__ + "static/media/dinero_renovacion.f293ea78.png";